module.exports = __webpack_public_path__ + "static/media/feature2permissions.6671b49f.png";